<template>
  <div class="layout-configuration">
    <slot name="headerBar" />

    <div class="configuration">
      <div
        :class="{
          'configuration__navigation': true,
          'configuration__navigation--hide': !isMainConfigurationPage(route?.name)
        }"
      >
        <router-link
          v-for="link in panelNavLinks"
          :key="link.locationType"
          activeClass="configuration__navigation-link--active"
          :class="{
            'configuration__navigation-link': true,
            'configuration__navigation-link--active': activeNav(link.name),
          }"
          :to="{ name: link.name }"
        >
          {{ link.label }}
          <RightArrowIcon class="icon hide-for-medium" />
        </router-link>
      </div>
      <div
        :class="{
          'configuration__panel-content': true,
          'configuration__panel-content--padding': !fullPanel && isDesktop(),
          'configuration__panel-content--height-full-mobile': !fullPanel,
          'configuration__panel-content--hide': isMainConfigurationPage(route?.name)
        }"
      >
        <slot name="panelContent" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

// Utils
import I18n from 'i18n-js';
import { useRoute } from 'vue-router';
import isDesktop from '@/functions/responsive';
import { isMainConfigurationPage } from '@/functions/configuration';

// Icons
import RightArrowIcon from '@/images/arrow-right.svg';

const route = useRoute();

const fullPanel = computed(() => {
  return ['editOrganisationConfiguration'].includes(route.name);
});

const panelNavLinks = computed(() => {
  const links = [
    {
      name: 'editOrganisationConfiguration',
      label: I18n.t('configuration.organisation.nav'),
    },
    {
      name: 'mineConfiguration',
      label: I18n.t('configuration.mine.nav'),
    },
    {
      name: 'operationTypeConfiguration',
      label: I18n.t('nav.plants'),
    },
    {
      name: 'equipmentProcessConfiguration',
      label: I18n.t('nav.equipment'),
    },
  ];

  return links;
});

const subNavLinks = computed(() => {
  const links = [
    {
      label: I18n.t('configuration.process.nav.processes'),
      value: 'equipmentProcessConfiguration',
      description: I18n.t('configuration.process.process_description')
    },
    {
      label: I18n.t('configuration.type.nav.types'),
      value: 'equipmentTypeConfiguration',
      description: I18n.t('configuration.type.type_description')
    },
  ];

  return [links[0].value, links[1].value].includes(route.name) ? links : null;
});

function activeNav(name) {
  return subNavLinks.value?.find(item => item.value === name);
}
</script>
